var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-autocomplete',_vm._b({ref:"input",scopedSlots:_vm._u([{key:"hidden",fn:function(ref){
var autocompleteList = ref.autocompleteList;
var selected = ref.selected;
var dropdownShow = ref.dropdownShow;
return [_vm._t("hidden",null,null,{ autocompleteList: autocompleteList, selected: selected, selectedPlace: _vm.selectedPlace, location: _vm.location, address: _vm.address, lat: _vm.lat, lng: _vm.lng, city: _vm.city, description: _vm.description,  dropdownShow: dropdownShow })]}},{key:"next",fn:function(ref){
var autocompleteList = ref.autocompleteList;
var selected = ref.selected;
var dropdownShow = ref.dropdownShow;
return [_vm._t("next",null,null,{ autocompleteList: autocompleteList, selected: selected, selectedPlace: _vm.selectedPlace, location: _vm.location, address: _vm.address, lat: _vm.lat, lng: _vm.lng, city: _vm.city, description: _vm.description, dropdownShow: dropdownShow })]}},{key:"prev",fn:function(ref){
var autocompleteList = ref.autocompleteList;
var selected = ref.selected;
var dropdownShow = ref.dropdownShow;
return [_vm._t("prev",null,null,{ autocompleteList: autocompleteList, selected: selected, selectedPlace: _vm.selectedPlace, location: _vm.location, address: _vm.address, lat: _vm.lat, lng: _vm.lng, city: _vm.city, description: _vm.description, dropdownShow: dropdownShow })]}}],null,true),model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'input-autocomplete',_vm.getInputProps({
        onSelect: _vm.onAutocompleteSelect,
        onKeyDown: _vm.onInputWrite,
        disableBlur: _vm.preventBlur,
        strictSelection: true,
        autocompleteOnVoid: false,
        defaultLoading: _vm.loading,
        defaultAutocompleteList: _vm.autocompleteList,
        autocompleteHandler: _vm.fetchAutocomplete,
        iconRight: _vm.iconRightClass,
        iconLoading: '',
        onIconRightClick: _vm.getCurrentLocation
    }),false))}
var staticRenderFns = []

export { render, staticRenderFns }